//#region \0plugin-vue:export-helper
var e = (e, t) => {
	let n = e.__vccOpts || e;
	for (let [e, r] of t) n[e] = r;
	return n;
};
//#endregion
export { e as t };
